import React from "react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Grid, List, ListItem } from "@mui/material";
import "../../Styles/Layouts/common_sidebar.css";
import { useLocation } from "react-router-dom";
import logo from "../../Assets/logo.svg";

const Admin_sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  //destructuring pathname from location
  const { pathname } = location;

  const handleLogout = () => {
    // Remove the token from local storage
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    navigate("/admin");
    window.location.reload();
  };

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  return (
    <React.Fragment>
      <Grid sx={{ width: "100%" }} container spacing={2}>
        <Grid sx={{ width: "17%" }} item lg={2}>
          <div className="sidebar-content">
            <div className="main-logo">
            <img src={logo} alt="logo" />
            </div>
            <List>
              <Link to="/admin/Dashboard">
                <ListItem
                  className={
                    splitLocation[1] === "admin" &&
                    splitLocation[2] === "Dashboard"
                      ? "active"
                      : ""
                  }
                >
                  Dashboard
                </ListItem>
              </Link>
              <Link to="/admin/FieldOfficers">
                <ListItem
                  className={
                    (splitLocation[1] === "admin" &&
                      splitLocation[2] === "FieldOfficers") ||
                    (splitLocation[1] === "admin" &&
                      splitLocation[2] === "FieldOfficerDetails") ||
                    (splitLocation[1] === "admin" &&
                      splitLocation[2] === "fieldofficerscheckins")
                      ? "active"
                      : ""
                  }
                >
                  Field Officers
                </ListItem>
              </Link>
              <Link to="/admin/Farmers">
                <ListItem
                  className={
                    splitLocation[1] === "admin" &&
                    splitLocation[2] === "Farmers"
                      ? "active"
                      : ""
                  }
                >
                  Farmers
                </ListItem>
              </Link>
              <Link to="/admin/Fields">
                <ListItem
                  className={
                    splitLocation[1] === "admin" &&
                    splitLocation[2] === "Fields"
                      ? "active"
                      : ""
                  }
                >
                  Fields
                </ListItem>
              </Link>
              <Link to="/admin/Locations">
                <ListItem
                  className={
                    splitLocation[1] === "admin" &&
                    splitLocation[2] === "Locations"
                      ? "active"
                      : ""
                  }
                >
                  Locations
                </ListItem>
              </Link>
            </List>
            <div className="logout-btn">
              <button className="logout" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </div>
        </Grid>
        <Grid item sx={{ width: "83%" }}>
          <Outlet />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Admin_sidebar;
